import { Autocomplete, Box, Checkbox, Chip, CircularProgress, FormControlLabel, FormGroup, ListItem, Radio, TextField, Typography } from "@mui/material";
import { memo, } from "react";
import { useSelector } from 'react-redux';
import CustomInput from "../../components/inputs/CustomInputs";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { CenteredBox } from "../../components/layouts/OneViewBox";
import { STATUS, USER_ROLES } from "../../utils/constants";
import FormControl from '@mui/material/FormControl';
import moment from "moment";
import { getProdutApi } from "../../apis/product.api";
import { StyledSearchBar } from "../../components/inputs/SearchBar"
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";
import { getsourceApi } from "../../apis/source.api";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import VerifiedIcon from '@mui/icons-material/Verified';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import FileInput from "../../components/upload/FileInput";

const UpdateCreateQueryUi = ({ listItem, statusPass, listProblem, title, modalKey, isUpdate, fields, setFields, loading, onSubmit, validation }) => {

    const user = useSelector(state => state.user)

    return (
        <>
            <CustomDialog
                id={`UpdateQuery`}
                loading={loading}
                err={fields.err}
                onSubmit={onSubmit}
                title={` Update ${title}`}
                closeText="Close"
                confirmText={`Update`}
            >
                {loading ? (
                    <CenteredBox><CircularProgress /></CenteredBox>
                ) : (
                    <>
                        <Box width={"90%"} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box display={"flex"} flexDirection={"column"}>
                                <Typography>
                                    Ticket Number: {fields?.ticket_no}
                                </Typography>
                            </Box>
                            <Box display={"flex"} flexDirection={"column"}>
                                <Typography>
                                    Date: {moment(fields?.createdAt).format("DD/MM/YYYY")}
                                </Typography>
                            </Box>
                        </Box>
                        <Box mt={3} width={"100%"}>
                            <PaddingBoxInDesktop mb={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end" }}  >
                                <AsyncDropDown
                                    disabled={user.data.role !== USER_ROLES.ADMIN}

                                    defaultVal={
                                        fields.product_id?._id ? {
                                            _id: fields.product_id?._id,
                                            name: fields.product_id?.name,
                                        } : null
                                    }
                                    lazyFun={async (para) => await getProdutApi({ ...para, allStatus: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.name}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFields({ ...fields, product_id: changedVal ? changedVal : null, })
                                    }}
                                    titleKey={'name'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <StyledSearchBar placeholder={"Select Product"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>

                            <Box mt={3}>
                                <Typography variant="h4">
                                    Customer Details :
                                </Typography>
                            </Box>
                            <CustomInput

                                disabled={user.data.role !== USER_ROLES.ADMIN}
                                value={fields.box_id}
                                onChange={(e) => setFields({ ...fields, err: '', box_id: e.target.value })}
                                type="text"
                                label={" Box Id.*"}
                            />
                            <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <CustomInput
                                    autoFocus={true}
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_name}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_name: e.target.value })}
                                    type="text"
                                    label={"Customer Name*"}
                                />
                                <CustomInput

                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_email}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_email: e.target.value })}
                                    type="text"
                                    label={"Email"}
                                />

                            </Box>
                            <Box gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <CustomInput

                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_phone}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_phone: e.target.value })}
                                    type="number"
                                    label={" Phone No.*"}
                                />
                                <CustomInput

                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.customer_address}
                                    onChange={(e) => setFields({ ...fields, err: '', customer_address: e.target.value })}
                                    type="text"
                                    label={"Address*"}
                                />

                            </Box>
                            <Box gap={3} mb={1} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields?.country?.name ? fields?.country?.name : fields?.country}
                                    onChange={(e) => setFields({ ...fields, err: '', country: e.target.value })}
                                    type="text"
                                    label={"Country*"}
                                />
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields?.state?.name ? fields?.state?.name : fields?.state}
                                    onChange={(e) => setFields({ ...fields, err: '', state: e.target.value })}
                                    type="text"
                                    label={"State*"}
                                />
                                <CustomInput
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields?.city?.name ? fields?.city?.name : fields?.city}
                                    onChange={(e) => setFields({ ...fields, err: '', city: e.target.value })}
                                    type="text"
                                    label={"City*"}
                                />
                            </Box>
                            <PaddingBoxInDesktop mt={2} sx={{ display: "flex", flex: 1, justifyContent: "flex-end", width: "100%" }}  >
                                <AsyncDropDown
                                    defaultVal={
                                        fields.source_id?._id ? {
                                            _id: fields.source_id?._id,
                                            title: fields.source_id?.title,
                                        } : null
                                    }
                                    disabled={user.data.role !== USER_ROLES.ADMIN}

                                    lazyFun={async (para) => await getsourceApi({ ...para, allStatus: true })}
                                    OptionComponent={({ option, ...rest }) => {
                                        return <ListItem {...rest}>{option.title}</ListItem >
                                    }}
                                    onChange={async (changedVal) => {
                                        setFields({ ...fields, source_id: changedVal ? changedVal._id : null, })
                                    }}
                                    titleKey={'title'}
                                    valueKey={"_id"}
                                    InputComponent={(params) => <StyledSearchBar placeholder={"Source*"} {...params} margin="none" />}
                                />
                            </PaddingBoxInDesktop>
                            <Box gap={3} mt={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <Autocomplete
                                    disabled={user.data.role !== USER_ROLES.ADMIN ? statusPass === STATUS.EVALUATION ? false : true : false}
                                    // value={listProblem?.filter(problem => fields.problems.includes(problem.name)) || []}
                                    value={
                                        listProblem?.filter(problem =>
                                            fields.problems.some(p => p.toLowerCase() === problem.name.toLowerCase())
                                        ) || []
                                    }
                                    sx={{ width: "100%", color: "primary.main" }}
                                    multiple
                                    onChange={(event, newValue) => {
                                        setFields({
                                            ...fields,
                                            err: "",
                                            problems: newValue.map((val) => val?.name),
                                        });
                                    }}
                                    options={listProblem ?? []}
                                    getOptionLabel={(option) => option.name}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => (
                                            <Chip label={option.name} {...getTagProps({ index })} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            margin="dense"
                                            {...params}
                                            label="Problems*"
                                            variant="outlined"
                                            placeholder="Select Problems"
                                        />
                                    )}
                                />
                                {fields.other && <CustomInput

                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    value={fields.other}
                                    onChange={(e) => setFields({ ...fields, err: '', other: e.target.value })}
                                    type="text"
                                    label={" Other Problems"}
                                />}
                            </Box>
                            <Box gap={3} mt={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                <Autocomplete
                                    disabled={true}
                                    value={fields?.product_accessories?.filter(accessories => fields.product_accessories.includes(accessories)) || []}
                                    sx={{ width: "100%", color: "primary.main" }}
                                    multiple
                                    onChange={(event, newValue) => {
                                        setFields({
                                            ...fields,
                                            err: "",
                                            product_accessories: newValue.map((val) => val?.name),
                                        });
                                    }}
                                    options={fields?.product_accessories ?? []}
                                    getOptionLabel={(option) => option}
                                    renderTags={(tagValue, getTagProps) =>
                                        tagValue.map((option, index) => (
                                            <Chip label={option} {...getTagProps({ index })} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            margin="dense"
                                            {...params}
                                            label="Product Accessories*"
                                            variant="outlined"
                                            placeholder="Selected Product Accessories"
                                        />
                                    )}
                                />
                            </Box>
                            {statusPass === STATUS.DEVICE_RECEIVED && <FormControl >
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(e) => {
                                                    setFields({
                                                        ...fields,
                                                        err: "",
                                                        status: [

                                                            {
                                                                status_role: STATUS.REPAIR_START,
                                                                role: USER_ROLES.REPAIR_TEAM
                                                            },
                                                            {
                                                                status_role: STATUS.SEND_TO_REPAIR,
                                                                role: USER_ROLES.CRM_TEAM
                                                            }, {
                                                                status_role: STATUS.SEND_TO_REPAIR,
                                                                role: USER_ROLES.LD
                                                            }
                                                        ]
                                                    });
                                                }}
                                            />
                                        }
                                        label="Repairing Start"
                                        labelPlacement="end"
                                    />
                                </FormGroup>
                            </FormControl>}
                            {(statusPass === STATUS.REPAIR_START) && <>

                                <DesktopDatePicker
                                    disableFuture
                                    inputFormat="DD/MM/yyyy"
                                    renderInput={(props) => <CustomInput {...props} />}
                                    autoFocus={true}
                                    disabled={user.data.role !== USER_ROLES.ADMIN}
                                    label="Purchase Date"
                                    value={fields?.warrenty_date ? moment(fields?.warrenty_date) : null}
                                    onChange={(val) => {
                                        if (val && val.isValid()) {
                                            const isoString = val.toISOString();
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: isoString,
                                            });
                                        } else {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                warrenty_date: "",
                                            });
                                        }
                                    }}
                                />
                                <Box mt={2} mb={3} >
                                    <Typography variant="h3">Device is : {validation ? <Chip color="error" icon={<PriorityHighIcon />} label="Expired Warranty" /> : <Chip color="success" icon={<VerifiedIcon />} label="Under Warranty" />}</Typography>
                                    <Box mt={3}
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-around",
                                            border: "1px solid black",
                                            borderRadius: "8px",
                                            padding: "7px",
                                            "@media (min-width: 490px)": {
                                                flexDirection: "row",
                                                alignItems: "center",
                                                justifyContent: "space-around",
                                            },
                                        }}
                                    >
                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    checked={fields.device_is === "physical_damage"}
                                                    onChange={(e) => {
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            device_is: e.target.name,
                                                            repairable_remarks: "",
                                                            replace_remarks: "",
                                                            repairing_amount: "",
                                                            repairable_part: [],
                                                            status: [

                                                                {
                                                                    status_role: STATUS.WAITING_FOR_PAYMENT,
                                                                    role: USER_ROLES.CRM_TEAM
                                                                },
                                                                {
                                                                    status_role: STATUS.WAITING_FOR_PAYMENT,
                                                                    role: USER_ROLES.LD
                                                                }, {
                                                                    status_role: STATUS.WAITING_FOR_PAYMENT,
                                                                    role: USER_ROLES.REPAIR_TEAM
                                                                }

                                                            ]
                                                        });
                                                    }}
                                                    name="physical_damage"
                                                />
                                            }
                                            label="Physical Damage"
                                            labelPlacement="end"
                                        />

                                        <FormControlLabel
                                            control={
                                                <Radio
                                                    checked={fields.device_is === "Repairable"}
                                                    onChange={(e) => {
                                                        let statusdata = [];
                                                        if (validation) {
                                                            statusdata = [
                                                                { status_role: STATUS.WAITING_FOR_PAYMENT, role: USER_ROLES.CRM_TEAM },
                                                                { status_role: STATUS.WAITING_FOR_PAYMENT, role: USER_ROLES.LD },
                                                                { status_role: STATUS.WAITING_FOR_PAYMENT, role: USER_ROLES.REPAIR_TEAM }
                                                            ];
                                                        } else {
                                                            statusdata = [
                                                                { status_role: STATUS.QC_CHECKED, role: USER_ROLES.REPAIR_TEAM },
                                                                { status_role: STATUS.SEND_TO_REPAIR, role: USER_ROLES.CRM_TEAM },
                                                                { status_role: STATUS.SEND_TO_REPAIR, role: USER_ROLES.LD }
                                                                // { status_role: STATUS.DISPATCH, role: USER_ROLES.LD },
                                                                // { status_role: STATUS.REPAIR_COMPLETED, role: USER_ROLES.REPAIR_TEAM },
                                                                // { status_role: STATUS.DISPATCH, role: USER_ROLES.CRM_TEAM }
                                                            ];
                                                        }
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            device_is: e.target.name,
                                                            physical_damage: {},
                                                            replace_remarks: "",
                                                            status: statusdata
                                                        });
                                                    }}
                                                    name="Repairable"
                                                />
                                            }
                                            label="Repairable"
                                            labelPlacement="end"
                                        />

                                        <FormControlLabel
                                            disabled={validation}
                                            control={
                                                <Radio
                                                    checked={fields.device_is === "Replace"}
                                                    onChange={(e) => {
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            repairable_remarks: "",
                                                            repairing_amount: "",
                                                            repairable_part: [],
                                                            physical_damage: {},
                                                            device_is: e.target.name,
                                                            status: [
                                                                {
                                                                    status_role: STATUS.QC_CHECKED,
                                                                    role: USER_ROLES.REPAIR_TEAM
                                                                }, {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.CRM_TEAM
                                                                }, {
                                                                    status_role: STATUS.SEND_TO_REPAIR,
                                                                    role: USER_ROLES.LD
                                                                }
                                                                // {
                                                                //     status_role: STATUS.DISPATCH,
                                                                //     role: USER_ROLES.LD
                                                                // },

                                                                // {
                                                                //     status_role: STATUS.REPLACEMENT,
                                                                //     role: USER_ROLES.REPAIR_TEAM
                                                                // },

                                                                // {
                                                                //     status_role: STATUS.DISPATCH,
                                                                //     role: USER_ROLES.CRM_TEAM
                                                                // }

                                                            ]
                                                        });
                                                    }}
                                                    name="Replace"
                                                />
                                            }
                                            label="Replacement"
                                            labelPlacement="end"
                                        />
                                    </Box>
                                </Box>

                                {fields.device_is === "physical_damage" && <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        options={listItem ?? []}
                                        value={
                                            listItem?.filter(item =>
                                                fields?.physical_damage?.damage_part?.some(
                                                    p => p === `${item.name} (${item.solution})`
                                                )
                                            ) || []
                                        }
                                        getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                        onChange={(event, newValue) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                physical_damage: {
                                                    ...fields.physical_damage,
                                                    damage_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                    repairing_amount: newValue.reduce((sum, val) => sum + (val?.price || 0), 0),
                                                },
                                            });
                                        }}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    label={`${option.name} (${option.solution})`}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="dense"
                                                label="Damage Part*"
                                                variant="outlined"
                                                placeholder="Damage Part"
                                            />
                                        )}
                                    />

                                    <CustomInput
                                        InputLabelProps={{ shrink: fields?.physical_damage?.repairing_amount && true }}
                                        disabled={loading}
                                        value={fields?.physical_damage?.repairing_amount}
                                        onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, repairing_amount: e.target.value } })}
                                        type="number"
                                        label={"Cost*"}
                                    />
                                    <CustomInput

                                        disabled={loading}
                                        value={fields?.physical_damage?.remarks}
                                        onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, remarks: e.target.value } })}
                                        type="text"
                                        label={"Remarks*"}
                                    />

                                </Box>}
                                {fields.device_is === "Repairable" && <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        options={listItem ?? []}
                                        value={
                                            listItem?.filter(item =>
                                                fields?.repairable_part?.some(
                                                    p => p === `${item.name} (${item.solution})`
                                                )
                                            ) || []
                                        }
                                        getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                        onChange={(event, newValue) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                repairable_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                repairing_amount: validation ? newValue.reduce((sum, val) => sum + (val?.price || 0), 0) : null
                                            });
                                        }}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    label={`${option.name} (${option.solution})`}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="dense"
                                                label="Damage Part*"
                                                variant="outlined"
                                                placeholder="Damage Part"
                                            />
                                        )}
                                    />

                                    {validation && <CustomInput
                                        InputLabelProps={{ shrink: fields?.repairing_amount && true }}
                                        disabled={loading}
                                        value={fields?.repairing_amount}
                                        onChange={(e) => setFields({ ...fields, err: '', repairing_amount: e.target.value })}
                                        type="number"
                                        label={"Cost*"}
                                    />}
                                    <CustomInput

                                        disabled={loading}
                                        value={fields?.repairable_remarks}
                                        onChange={(e) => setFields({ ...fields, err: '', repairable_remarks: e.target.value })}
                                        type="text"
                                        label={"Remarks*"}
                                    />
                                </Box>}
                                {fields.device_is === "Replace" && <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <CustomInput
                                        autoFocus={true}
                                        disabled={loading}
                                        value={fields?.replace_remarks}
                                        onChange={(e) => setFields({ ...fields, err: '', replace_remarks: e.target.value })}
                                        type="text"
                                        label={"Remarks*"}
                                    />
                                </Box>}
                                <Box>
                                    <FileInput
                                        onDelete={(filesToDelete) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                before_photo: ""
                                            })
                                        }}
                                        onChange={(files) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                before_photo: files
                                            })
                                        }}
                                        defaults={fields?.before_photo ? [fields?.before_photo] : []}
                                        accept="image/*"
                                        onlyImage
                                        title="Before Photo"
                                        subTitle="Only png,jpeg,jpg files are allowed! less than 1 MB"
                                    />
                                </Box>
                            </>}

                            {((statusPass === STATUS.PAYMENT_RECEIVED) || (statusPass === STATUS.REPAIR_DEMO)) && <>
                                {(fields.device_is === "physical_damage") &&
                                    <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Autocomplete
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            multiple
                                            fullWidth
                                            options={listItem ?? []}
                                            value={
                                                listItem?.filter(item =>
                                                    fields?.physical_damage?.damage_part?.some(
                                                        p => p === `${item.name} (${item.solution})`
                                                    )
                                                ) || []
                                            }
                                            getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                            onChange={(event, newValue) => {
                                                setFields({
                                                    ...fields,
                                                    err: "",
                                                    physical_damage: {
                                                        ...fields.physical_damage,
                                                        damage_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                        repairing_amount: newValue.reduce((sum, val) => sum + (val?.price || 0), 0),
                                                    },
                                                });
                                            }}
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        label={`${option.name} (${option.solution})`}
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="dense"
                                                    label="Damage Part*"
                                                    variant="outlined"
                                                    placeholder="Damage Part"
                                                />
                                            )}
                                        />
                                        <CustomInput
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={fields?.physical_damage?.repairing_amount}
                                            onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, repairing_amount: e.target.value } })}
                                            type="number"
                                            InputLabelProps={{ shrink: fields?.physical_damage?.repairing_amount && true }}
                                            label={"Cost*"}
                                        />
                                        <CustomInput
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={fields?.physical_damage?.remarks}
                                            onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, remarks: e.target.value } })}
                                            type="text"
                                            label={"Remarks*"}
                                        />


                                    </Box>}
                                {fields.device_is === "Repairable" && <Box mt={1} mb={2} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Autocomplete
                                        multiple
                                        fullWidth
                                        options={listItem ?? []}
                                        disabled={user.data.role !== USER_ROLES.ADMIN}
                                        value={
                                            listItem?.filter(item =>
                                                fields?.repairable_part?.some(
                                                    p => p === `${item.name} (${item.solution})`
                                                )
                                            ) || []
                                        }
                                        getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                        onChange={(event, newValue) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                repairable_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                repairing_amount: validation ? newValue.reduce((sum, val) => sum + (val?.price || 0), 0) : null
                                            });
                                        }}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    label={`${option.name} (${option.solution})`}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="dense"
                                                label="Damage Part*"
                                                variant="outlined"
                                                placeholder="Damage Part"
                                            />
                                        )}
                                    />
                                    {validation && <CustomInput
                                        InputLabelProps={{ shrink: fields?.repairing_amount && true }}
                                        disabled={user.data.role !== USER_ROLES.ADMIN}
                                        value={fields?.repairing_amount}
                                        onChange={(e) => setFields({ ...fields, err: '', repairing_amount: e.target.value })}
                                        type="number"
                                        label={"Cost*"}
                                    />}
                                    <CustomInput

                                        disabled={user.data.role !== USER_ROLES.ADMIN}

                                        value={fields?.repairable_remarks}
                                        onChange={(e) => setFields({ ...fields, err: '', repairable_remarks: e.target.value })}
                                        type="text"
                                        label={"Remarks*"}
                                    />

                                </Box>}
                                <FormControl >
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            status: fields.repairing_amount_status === "CANCEL_PAYMENT" ?
                                                                [

                                                                    {
                                                                        status_role: STATUS.DEMO,
                                                                        role: USER_ROLES.REPAIR_TEAM
                                                                    },
                                                                    {
                                                                        status_role: STATUS.DEMO,
                                                                        role: USER_ROLES.LD
                                                                    },
                                                                    {
                                                                        status_role: STATUS.DEMO,
                                                                        role: USER_ROLES.CRM_TEAM
                                                                    }

                                                                ]
                                                                :
                                                                [
                                                                    {
                                                                        status_role: STATUS.QC_CHECKED,
                                                                        role: USER_ROLES.REPAIR_TEAM
                                                                    },
                                                                    {
                                                                        status_role: STATUS.SEND_TO_REPAIR,
                                                                        role: USER_ROLES.CRM_TEAM
                                                                    }, {
                                                                        status_role: STATUS.SEND_TO_REPAIR,
                                                                        role: USER_ROLES.LD
                                                                    }
                                                                    // {
                                                                    //     status_role: STATUS.DISPATCH,
                                                                    //     role: USER_ROLES.LD
                                                                    // },
                                                                    // {
                                                                    //     status_role: STATUS.DISPATCH,
                                                                    //     role: USER_ROLES.CRM_TEAM
                                                                    // },

                                                                    // {
                                                                    //     status_role: STATUS.REPAIR_COMPLETED,
                                                                    //     role: USER_ROLES.REPAIR_TEAM
                                                                    // }
                                                                ]
                                                        });
                                                    }}
                                                />
                                            }
                                            label="Repairing Complete"
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </>}
                            {statusPass === STATUS.QC_CHECKED && <>
                                {(fields.device_is === "physical_damage") &&
                                    <Box mt={1} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Autocomplete
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            multiple
                                            fullWidth
                                            options={listItem ?? []}
                                            value={
                                                listItem?.filter(item =>
                                                    fields?.physical_damage?.damage_part?.some(
                                                        p => p === `${item.name} (${item.solution})`
                                                    )
                                                ) || []
                                            }
                                            getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                            onChange={(event, newValue) => {
                                                setFields({
                                                    ...fields,
                                                    err: "",
                                                    physical_damage: {
                                                        ...fields.physical_damage,
                                                        damage_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                        repairing_amount: newValue.reduce((sum, val) => sum + (val?.price || 0), 0),
                                                    },
                                                });
                                            }}
                                            renderTags={(tagValue, getTagProps) =>
                                                tagValue.map((option, index) => (
                                                    <Chip
                                                        label={`${option.name} (${option.solution})`}
                                                        {...getTagProps({ index })}
                                                    />
                                                ))
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    margin="dense"
                                                    label="Damage Part*"
                                                    variant="outlined"
                                                    placeholder="Damage Part"
                                                />
                                            )}
                                        />
                                        <CustomInput
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={fields?.physical_damage?.repairing_amount}
                                            onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, repairing_amount: e.target.value } })}
                                            type="number"
                                            InputLabelProps={{ shrink: fields?.physical_damage?.repairing_amount && true }}
                                            label={"Cost*"}
                                        />
                                        <CustomInput
                                            disabled={user.data.role !== USER_ROLES.ADMIN}
                                            value={fields?.physical_damage?.remarks}
                                            onChange={(e) => setFields({ ...fields, err: '', physical_damage: { ...fields.physical_damage, remarks: e.target.value } })}
                                            type="text"
                                            label={"Remarks*"}
                                        />


                                    </Box>}
                                {fields.device_is === "Repairable" && <Box mt={1} mb={2} gap={3} flexDirection={"row"} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <Autocomplete
                                        disabled={user.data.role !== USER_ROLES.ADMIN}
                                        multiple
                                        fullWidth
                                        options={listItem ?? []}
                                        value={
                                            listItem?.filter(item =>
                                                fields?.repairable_part?.some(
                                                    p => p === `${item.name} (${item.solution})`
                                                )
                                            ) || []
                                        }
                                        getOptionLabel={(option) => `${option.name} (${option.solution})`}
                                        onChange={(event, newValue) => {
                                            setFields({
                                                ...fields,
                                                err: "",
                                                repairable_part: newValue.map((val) => `${val.name} (${val.solution})`),
                                                repairing_amount: validation ? newValue.reduce((sum, val) => sum + (val?.price || 0), 0) : null
                                            });
                                        }}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    label={`${option.name} (${option.solution})`}
                                                    {...getTagProps({ index })}
                                                />
                                            ))
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="dense"
                                                label="Damage Part*"
                                                variant="outlined"
                                                placeholder="Damage Part"
                                            />
                                        )}
                                    />
                                    {validation && <CustomInput
                                        InputLabelProps={{ shrink: fields?.repairing_amount && true }}
                                        disabled={user.data.role !== USER_ROLES.ADMIN}
                                        value={fields?.repairing_amount}
                                        onChange={(e) => setFields({ ...fields, err: '', repairing_amount: e.target.value })}
                                        type="number"
                                        label={"Cost*"}
                                    />}
                                    <CustomInput

                                        disabled={user.data.role !== USER_ROLES.ADMIN}

                                        value={fields?.repairable_remarks}
                                        onChange={(e) => setFields({ ...fields, err: '', repairable_remarks: e.target.value })}
                                        type="text"
                                        label={"Remarks*"}
                                    />

                                </Box>}
                                <Box>
                                    <FileInput
                                        onDelete={(filesToDelete) => {
                                            setFields((prevFields) => ({
                                                ...prevFields,
                                                err: "",
                                                after_photo: fields.after_photo.filter(file => !filesToDelete.includes(file))
                                            }));
                                        }}
                                        onChange={(newFiles) => {
                                            setFields((prevFields) => ({
                                                ...prevFields,
                                                err: "",
                                                after_photo: [...fields.after_photo, newFiles]
                                            }));
                                        }}
                                        defaults={fields?.after_photo}
                                        accept="image/*"
                                        onlyImage
                                        title="After Photo"
                                        subTitle="Only png,jpeg,jpg files are allowed! less than 1 MB"
                                        multi={true}
                                    />
                                </Box>
                                <FormControl >
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={(e) => {
                                                        setFields({
                                                            ...fields,
                                                            err: "",
                                                            status:
                                                                [
                                                                    {
                                                                        status_role: STATUS.DISPATCH,
                                                                        role: USER_ROLES.LD
                                                                    },
                                                                    {
                                                                        status_role: STATUS.DISPATCH,
                                                                        role: USER_ROLES.CRM_TEAM
                                                                    },

                                                                    {
                                                                        status_role: STATUS.REPAIR_COMPLETED,
                                                                        role: USER_ROLES.REPAIR_TEAM
                                                                    }
                                                                ]
                                                        });
                                                    }}
                                                />
                                            }
                                            label="Qc Checked"
                                            labelPlacement="end"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </>}
                        </Box>
                    </>
                )}
            </CustomDialog >
        </>
    );
}

export default memo(UpdateCreateQueryUi);

{/* <Autocomplete
    disabled={loading}
    value={
        listItem?.filter(item =>
            fields?.repairable_part?.some(p => p.toLowerCase() === item.name.toLowerCase())
        ) || []
    }
    sx={{ width: "100%", color: "primary.main" }}
    multiple
    onChange={(event, newValue) => {
        setFields({
            ...fields,
            err: "",
            repairable_part: newValue.map((val) => val?.name),
            repairing_amount: validation ? newValue.reduce((sum, val) => sum + (val?.price || 0), 0) : null
        });
    }}
    options={listItem ?? []}
    getOptionLabel={(option) => option.name}
    renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
            <Chip label={option.name} {...getTagProps({ index })} />
        ))
    }
    renderInput={(params) => (
        <TextField
            margin="dense"
            {...params}
            label="Which part you repaired*"
            variant="outlined"
            placeholder="Which part you repaired"
        />
    )}
/> */}
